/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IndicatorDTO,
    IndicatorDTOFromJSON,
    IndicatorDTOFromJSONTyped,
    IndicatorDTOToJSON,
} from './IndicatorDTO';

/**
 * 
 * @export
 * @interface IndicatorDTOPagedResponse
 */
export interface IndicatorDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof IndicatorDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof IndicatorDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof IndicatorDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<IndicatorDTO>}
     * @memberof IndicatorDTOPagedResponse
     */
    data?: Array<IndicatorDTO> | null;
}

export function IndicatorDTOPagedResponseFromJSON(json: any): IndicatorDTOPagedResponse {
    return IndicatorDTOPagedResponseFromJSONTyped(json, false);
}

export function IndicatorDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndicatorDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(IndicatorDTOFromJSON)),
    };
}

export function IndicatorDTOPagedResponseToJSON(value?: IndicatorDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(IndicatorDTOToJSON)),
    };
}

